import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth is httpOnly-cookie-only. `withCredentials: true` ensures the
// browser sends/receives the secure access_token + refresh_token cookies
// the backend sets on /api/auth/{login,register}. We deliberately do NOT
// keep a JS-accessible token (no localStorage / sessionStorage) to avoid
// XSS exfiltration. Server still accepts Authorization: Bearer for
// out-of-browser clients (curl, pytest) that pass it explicitly.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
